// extracted by mini-css-extract-plugin
export default {"introductionMediaSection":"IntroductionMedia_introductionMediaSection__P4CJ6","introductionMedia":"IntroductionMedia_introductionMedia__tx0l4"};